// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import {defineStore} from 'pinia'
import {ProductInterface} from "@/core/types";

import {usePaginationStore} from "@/store/SerpPage/PaginationStore";
import {useSerpResultsStore} from "@/store/SerpPage/SerpResultsStore";
import {useFiltersStore} from "@/store/SerpPage/FiltersStore";
import {useSearchQueryStore} from "@/store/SearchQueryStore";
import {usePopupStore} from "@/store/AutocompletePopup/PopupStore";
import {useUserRecentQueriesStore} from "@/store/AutocompletePopup/UserRecentQueriesStore";

export const useUrlStore = defineStore('UrlStore', {
  state: () => {
    return {
      products: [] as ProductInterface[],
      filters: {},
      price: {},
      sort: '',
      query: '',
      total: null,
      page: 0,
      totalPage: null,
      loading: false,
      initialised: false,
      urlStore: window.location.href
    }
  },
  getters: {},
  actions: {
    
    composeUrlParams(url: URL) {
      url = new URL(url)
      const isHashBeforeSearchParams = useSearchQueryStore().getIsHashBeforeSearchParams;
      if (!isHashBeforeSearchParams) {
        return url.toString()
      }
      const hashParams = url.searchParams ? url.searchParams.toString() : '';
      url.hash = '';
      url.search = '';
      
      return `${url.href}#${hashParams}`
    },
    
    decomposeUrl() {
      const url = new URL(location);
      const isHashBeforeSearchParams = useSearchQueryStore().getIsHashBeforeSearchParams;
      if (isHashBeforeSearchParams) {
        const params = new URLSearchParams(location.hash.substring(1));
        for (const [key, value] of params) {
          url.searchParams.append(key, value)
        }
      }
      return url;
    },
    
    updateUrl(url: URL, redirectUrl = null) {
      const needRedirect = redirectUrl && location.pathname !== redirectUrl
      const preparedUrl = this.composeUrlParams(url)
      if (needRedirect || !window.history) {
        window.location.href = preparedUrl
        return
      }
      window.history.pushState({path: preparedUrl}, '', preparedUrl)
    },
    
    async goToSerpPage(url: string, redirectUrl: string | null = null, query: string | '' = '') {
      this.updateUrl(new URL(window.location.origin + url), redirectUrl)
      const userRecentQueriesStore = useUserRecentQueriesStore()
      const filtersStore = useFiltersStore()
      const serpStore = useSerpResultsStore()
      const paginationStore = usePaginationStore();
      const queryStore = useSearchQueryStore();
      const popupStore = usePopupStore();
      if (query) {
        queryStore.updateQuery(query)
        userRecentQueriesStore.addQuery(query)
      }
      
      popupStore.hideAutocomplete()
      paginationStore.resetPageValue()
      
      await filtersStore.fetchFiltersAnProducts()
      if (typeof window.afterGoToSerpPage !== 'undefined') {
        window.afterGoToSerpPage()
      }
      serpStore.scrollIntoView()
    },
    
    removePageParameter(url: URL): void {
      url.searchParams.delete('p');
    },
    removeFiltersFromUrl() {
      const url = useUrlStore().decomposeUrl()
      for (const key of Array.from(url.searchParams.keys())) {
        if (!key.match(/q/)) {
          url.searchParams.delete(key);
        }
      }
      this.updateUrl(url)
    },
    addFilterToParameters(url: URL, field: string, filterValue: string): void {
      url.searchParams.set(`f[${field}]`, JSON.stringify(filterValue));
    },
    removeFilterFromParameters(url: URL, field: string): void {
      url.searchParams.delete(`f[${field}]`);
    },
    
    updateFiltersParameters(url: URL, field: string, filterValue: string): void {
      if (filterValue.length > 0) {
        this.addFilterToParameters(url, field, filterValue)
      } else {
        this.removeFilterFromParameters(url, field)
      }
    },
    
    removeRangeFilterFromParameters(url: URL, field: string): void {
      url.searchParams.delete(`f[${field}]`);
    },
    
    addRangeFiltersToParameters(url: URL, field: string, rangeData): void {
      url.searchParams.set(`f[${field}]`, JSON.stringify(rangeData));
    },
    
    updateSortParameter(paramValue: string) {
      const url = useUrlStore().decomposeUrl()
      url.searchParams.set('s', paramValue)
      this.updateUrl(url)
    },
    
    async clearQuery(redirectionUrl: string, autocomplete: boolean) {
      const url = useUrlStore().decomposeUrl()
      const queryStore = useSearchQueryStore()
      url.searchParams.delete('q')
      queryStore.clearQuery()
      if (autocomplete) {
        return
      }
      this.updateUrl(url)
      await this.goToSerpPage(redirectionUrl)
    },
    
    updatePageParameter(page: number): void {
      const url = useUrlStore().decomposeUrl()
      if (page === 0) {
        this.removePageParameter(url)
      } else {
        url.searchParams.set('p', page);
      }
      this.updateUrl(url);
    },
    
  },
})
